import React from "react";
import { Button, Dropdown, Form, Modal } from "react-bootstrap";
import NumberFormat from "react-number-format";
import cogoToast from "cogo-toast";
import { FILTER_TYPE } from "../discovery/discoveryReducer";
import { DEFAULT_DISCOVERY_SECTOR, LAST_AT_FILTER_DEFAULT_THRESHOLD, LAST_AT_FILTER_UNIT, SECTORS_FILTER, TIMEFRAME_FILTER, TREND_CHANGE_TYPE, TREND_TYPE } from "../constants";
import API from '../api';

class SettingFilteredAlertModal extends React.Component {
  columns = ["atr", "avgVolume", "float", "gap", "halt", "last", "price_dist", "momentum", "mf_price", "mf_dist", "news", "rs", "short_ratio", "squeeze", "trend", "trend_change", "uVol", "rv_price", "rv_dist", "vWapDist"];
  minMaxColumns = ["avgVolume", "float", "last", "momentum", "mf_price", "short_ratio", "rs", "rv_price", "atr", "gap"];
  singleColumns = ["price_dist", "uVol", "vWapDist", "mf_dist", "rv_dist"];

  state = {
    mode: "add",
    name: "",
    type: FILTER_TYPE.ALL,
    filters: [{ column: "", min: "", max: "" }],
    filterSector: [],
    filterTimeframe: "",
    loading: false,
    isFormSubmitted: false,
    sectorDropdownShown: false
  };

  updatingFilterName = '';

  getColumnTitle = (col) => {
    if (col === "avgVolume") {
      return "Avg Volume";
    }
    if (col === "float") {
      return "Float";
    }
    if (col === "last") {
      return "Last";
    }
    if (col === "momentum") {
      return "Momentum";
    }
    if (col === "mf_price") {
      return "Money Flow $";
    }
    if (col === "mf_dist") {
      return "Money Flow %";
    }
    if (col === "price_dist") {
      return "Last %";
    }
    if (col === "squeeze") {
      return "Squeeze";
    }
    if (col === "trend") {
      return "Trend";
    }
    if (col === "trend_change") {
      return "Trend Change";
    }
    if (col === "uVol") {
      return "UVol";
    }
    if (col === "vWapDist") {
      return "VWAPDist";
    }
    if (col === "rs") {
      return "RelStr %";
    }
    if (col === "rv_price") {
      return "Volume"
    }
    if (col === 'rv_dist') {
      return "Volume %";
    }
    if (col === "short_ratio") {
      return "Short Ratio";
    }
    if (col === "atr") {
      return "ATR %";
    }
    if (col === "gap") {
      return "Gap %";
    }
    if (col === "news") {
      return "News";
    }
    if (col === "halt") {
      return "Halt";
    }
    return col;
  };

  addRow = () => {
    if (this.state.filters.length < this.columns.length) {
      const filters = [...this.state.filters];
      filters.push({
        column: "",
        min: "",
        max: "",
      });
      this.setState({
        filters,
      });
    }
  };

  updateFilterColumn = (index, c) => {
    const filters = [...this.state.filters];
    filters[index].column = c;
    if (c === 'squeeze') {
      filters[index].min = {
        NOW: false,
        PRE: false,
        POST: false,
      }
      filters[index].max = ""
    } else if (c === 'trend') {
      filters[index].min = TREND_TYPE.BUY;
      filters[index].max = "";
    } else if (c === 'trend_change') {
      filters[index].min = TREND_CHANGE_TYPE.BUY_TO_SELL;
      filters[index].max = "";
    } else if (c === "news" || c === "halt") {
      filters[index].min = {
        threshold: LAST_AT_FILTER_DEFAULT_THRESHOLD,
        unit: LAST_AT_FILTER_UNIT[1]
      }
    } else {
      filters[index].min = ""
      filters[index].max = ""
    }
    this.setState({
      filters,
    });
  };

  updateFilterValue = (index, type, value) => {
    const filters = [...this.state.filters];
    filters[index][type] = value;
    this.setState({
      filters,
    });
  };

  updateFilterType = (type) => {
    this.setState({
      type,
    });
  };

  deleteFilterRow = (index) => {
    const filters = [...this.state.filters];
    filters.splice(index, 1);
    this.setState({
      filters,
    });
  };

  clear = () => {
    this.setState({
      name: "",
      type: FILTER_TYPE.ALL,
      filters: [{ column: "", min: "", max: "" }],
    });
  };

  initForAdd = () => {
    this.setState({
      mode: "add",
      name: "",
      type: FILTER_TYPE.ALL,
      filters: [{ column: "", min: "", max: "" }],
      filterSector: [],
      filterTimeframe: "",
      loading: false,
      isFormSubmitted: false,
      sectorDropdownShown: false
    });
  }

  initForUpdate = (filter) => {
    const values = [];
    let filterSector = [];
    let filterTimeframe = "";
    for (let key in filter.values) {
      let { min, max } = filter.values[key];
      if (key === 'sector') {
        if (Array.isArray(min)) filterSector = min;
        else filterSector = [];
        continue;
      }
      if (key === 'timeframe') {
        filterTimeframe = min || "";
        continue;
      }
      if (key === 'squeeze') {
        if (Object.prototype.toString.call(min) !== '[object Object]') {
          min = {};
        } else {
          if (min['PRE'] === true) min['PRE'] = 7;
          if (min['POST'] === true) min['POST'] = -2;
        }
        max = null;
      } else if (key === "trend") {
        if (min !== TREND_TYPE.BUY && min !== TREND_TYPE.SELL) {
          min = TREND_TYPE.BUY;
        }
        max = "";
      } else if (key === "trend_change") {
        if (min !== TREND_CHANGE_TYPE.BUY_TO_SELL && min !== TREND_CHANGE_TYPE.SELL_TO_BUY) {
          min = TREND_CHANGE_TYPE.BUY_TO_SELL;
        }
        max = "";
      } else if (key === "news" || key === "halt") {
        if (Object.prototype.toString.call(min) !== '[object Object]') {
          min = {};
        } else {
          if (isNaN(min['threshold'])) min['threshold'] = LAST_AT_FILTER_DEFAULT_THRESHOLD;
          if (!LAST_AT_FILTER_UNIT.includes(min['unit'])) min['unit'] = LAST_AT_FILTER_UNIT[1];
        }
        max = null;
      } else {
        if (isNaN(min)) min = "";
        else if (!min && min !== 0 && min !== '0') min = "";
        if (isNaN(max)) max = "";
        else if (!max && max !== 0 && max !== '0') max = "";
      }
      values.push({
        column: key,
        min: min,
        max: max
      })
    }

    this.updatingFilterName = filter.name;
    this.setState({
      mode: "edit",
      name: filter.name,
      type: filter.type,
      filters: [
        ...values
      ],
      filterSector: filterSector,
      filterTimeframe: filterTimeframe,
      loading: false,
      isFormSubmitted: false,
      sectorDropdownShown: false
    });
  };

  updateFilterName = (name) => {
    this.setState({
      name,
    });
  };

  isFormValidBasic = () => {
    const { name, filters } = this.state;
    if (!name || !filters.length) {
      return false;
    }
    const validFilters = filters.filter(item => {
      if (!item.column) return false;
      if (item.column === 'squeeze') {
        if (!item.min || Object.keys(item.min).length === 0) return false;
        const checkedCnt = Object.keys(item.min).filter(key => item.min[key]).length;
        if (checkedCnt === 0) return false;
      } else if (item.column === 'trend') {
        if (item.min !== TREND_TYPE.BUY && item.min !== TREND_TYPE.SELL) return false;
      } else if (item.column === 'trend_change') {
        if (item.min !== TREND_CHANGE_TYPE.BUY_TO_SELL && item.min !== TREND_CHANGE_TYPE.SELL_TO_BUY) return false;
      } else if (item.column === 'news' || item.column === 'halt') {
        if (isNaN(item.min?.threshold) || item.min?.threshold <= 0 || !LAST_AT_FILTER_UNIT.includes(item.min?.unit)) return false;
      } else {
        if ((!item.min && item.min !== 0) && (!item.max && item.max !== 0)) return false;
      }
      return true;
    });
    if (validFilters.length < filters.length) {
      return false;
    }
    return true;
  }

  isFormValidMinMax = () => {
    const { filters } = this.state;
    const invalidMinMaxFilters = filters.filter(item => {
      if (item.column && item.column !== 'squeeze' && item.column !== 'trend' && item.column !== 'trend_change' && item.column !== 'news' && item.column !== 'halt' && !this.singleColumns.includes(item.column)) {
        if ((item.min || item.min === 0) && (item.max || item.max === 0) && item.max < item.min) return true;
      }
      return false;
    });
    return invalidMinMaxFilters.length === 0;
  }

  isFormValidSingleColumn = () => {
    const { filters } = this.state;
    const validSingleValueFilters = filters.filter(item => {
      if (!item.column || !(this.singleColumns.includes(item.column) || item.column === 'squeeze' || item.column === 'trend_change' || item.column === 'news' || item.column === 'halt')) return false;
      if (!item.min && item.min !== 0) return false;
      return true;
    });
    return validSingleValueFilters.length > 0;
  }

  isFormValidAttribute = () => {
    const { filterSector, filterTimeframe } = this.state;
    if (!filterSector || !filterSector.length || !filterTimeframe) {
      return false;
    }
    return true;
  }

  isFormValid = () => {
    return this.isFormValidBasic() && this.isFormValidMinMax() && this.isFormValidAttribute() && this.isFormValidSingleColumn();
  }

  handleSave = async () => {
    try {
      this.setState({isFormSubmitted: true});

      if (!this.isFormValid()) {
        return;
      }

      const alertItem = {
        name: this.state.name,
        type: this.state.type,
        values: {
          ...this.state.filters.reduce((acc, curr) => {
            acc[curr.column] = {
              min: curr.column === 'squeeze' || curr.column === 'trend' || curr.column === 'trend_change' || curr.column === 'news' || curr.column === 'halt' ? curr.min : parseFloat(curr.min),
              max: parseFloat(curr.max),
            };
            return acc;
          }, {}),
          "sector": {
            "min": this.state.filterSector, "max": ""
          },
          "timeframe": {
            "min": this.state.filterTimeframe, "max": ""
          }
        },
      };

      this.setState({ loading: true })
      const { hide: hideToast } = cogoToast.loading('Validating alert coverage');

      const response = await API.validateFilteredAlert(alertItem);
      hideToast();

      this.setState({ loading: false })

      if (!response) throw 'err';
      if (!response.valid) {
        const { hide: hideErrorToast } = cogoToast.error(
          <span onClick={() => {hideErrorToast()}}>
            Validation error: Possible result contains <b>{response.values[1]}</b> symbols.<br/>
            Please decrease range or add conditions to reduce to <b>{response.values[0]}</b> or less.
          </span>
          , {
            hideAfter: 5
          }
        )
        return;
      }

      this.props.onAdd(alertItem);
      // this.clear();
      // this.props.onHide(false);
    } catch (e) {
      this.setState({ loading: false })
      cogoToast.error(
        `Failed to validate filtered alert`
      );
    }
  };

  handleUpdate = async () => {
    try {
      this.setState({isFormSubmitted: true});

      if (!this.isFormValid()) {
        return;
      }

      const alertItem = {
        name: this.state.name,
        type: this.state.type,
        values: {
          ...this.state.filters.reduce((acc, curr) => {
            acc[curr.column] = {
              min: curr.column === 'squeeze' || curr.column === 'trend' || curr.column === 'trend_change' || curr.column === 'news' || curr.column === 'halt' ? curr.min : parseFloat(curr.min),
              max: parseFloat(curr.max),
            };
            return acc;
          }, {}),
          "sector": {
            "min": this.state.filterSector, "max": ""
          },
          "timeframe": {
            "min": this.state.filterTimeframe, "max": ""
          }
        },
      };

      this.setState({ loading: true })
      const { hide: hideToast } = cogoToast.loading('Validating alert coverage');

      const response = await API.validateFilteredAlert(alertItem);
      hideToast();

      this.setState({ loading: false })

      if (!response) throw 'err';
      if (!response.valid) {
        const { hide: hideErrorToast } = cogoToast.error(
          <span onClick={() => {hideErrorToast()}}>
            Validation error: Possible result contains <b>{response.values[1]}</b> symbols.<br/>
            Please decrease range or add conditions to reduce to <b>{response.values[0]}</b> or less.
          </span>
          , {
            hideAfter: 5
          }
        )
        return;
      }

      this.props.onUpdate(this.updatingFilterName, alertItem);
    } catch (e) {
      this.setState({ loading: false })
      cogoToast.error(
        `Failed to validate filtered alert`
      );
    }
  }

  isMoneyColumn = (column) => {
    return column === 'last' || column === 'mf_price';
  }

  isPercentColumn = (column) => {
    return column === 'price_dist' || column === 'uVol' || column === 'vWapDist' || column === 'mf_dist' || column === 'rv_dist' || column === 'atr' || column === 'gap' || column === 'rs';
  }

  isMinMaxColumn = (column) => {
    return this.minMaxColumns.includes(column);
  }

  isSingleValueColumn = (column) => {
    return this.singleColumns.includes(column);
  }

  renderSingleValueFilterItem = (index, filter) => {
    return (
      <div className="d-flex flex-row align-items-center">
        <Form.Label
          className="my-1 mr-1 ml-2 d-none d-sm-block min-max-label"
          htmlFor="inlineMin"
        >
          Value
        </Form.Label>
        <NumberFormat
          thousandSeparator={true}
          className="form-control form-control-sm px-1 ml-1 text-right"
          inputMode="numeric"
          placeholder="value"
          prefix={this.isMoneyColumn(filter.column) ? '$' : ''}
          suffix={this.isPercentColumn(filter.column) ? '%' : ''}
          style={{color: 'white'}}
          value={filter.min}
          onValueChange={(values) => {
            this.updateFilterValue(index, "min", values.floatValue);
          }}
          />
      </div>)
  }

  renderMinMaxFilterItem = (index, filter) => {
    return (
    <div className="d-flex flex-row align-items-center">
      <Form.Label
        className="my-1 mr-1 ml-2 d-none d-sm-block min-max-label"
        htmlFor="inlineMin"
      >
        Min
      </Form.Label>
      <NumberFormat
        thousandSeparator={true}
        className="form-control form-control-sm px-1 ml-1 text-right"
        inputMode="numeric"
        placeholder="min"
        prefix={this.isMoneyColumn(filter.column) ? '$' : ''}
        suffix={this.isPercentColumn(filter.column) ? '%' : ''}
        style={{color: 'white'}}
        value={filter.min}
        onValueChange={(values) => {
          this.updateFilterValue(index, "min", values.floatValue);
        }}
        />
      <Form.Label
        className="my-1 mr-1 ml-2 d-none d-sm-block min-max-label"
        htmlFor="inlineMax"
      >
        Max
      </Form.Label>
      <NumberFormat
        thousandSeparator={true}
        className="form-control form-control-sm px-1 ml-1 text-right"
        inputMode="numeric"
        placeholder="max"
        prefix={this.isMoneyColumn(filter.column) ? '$' : ''}
        suffix={this.isPercentColumn(filter.column) ? '%' : ''}
        style={{color: 'white'}}
        value={filter.max}
        onValueChange={(values) => {
          this.updateFilterValue(index, "max", values.floatValue);
        }}
        />
    </div>)
  }

  renderSqueezeFilterItem = (index, filter) => {
    const values = ['PRE', 'NOW', 'POST'];
    return (
      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-baseline align-items-sm-center flex-grow-1 pl-1 pl-sm-4">
      {
        values.map((item, id) => (
          <div key={`filter-squeeze-${id}`} className={`input-group-checkbox`} onClick={() => {
            const min = filter.min;
            if (!min[item]) {
              if (item === 'PRE') {
                if (min['POST']) return
                else {
                  min[item] = 7
                }
              } else if (item === 'POST') {
                if (min['PRE']) return
                else {
                  min[item] = -2
                }
              } else {
                if (min['PRE'] && min['POST']) return
                else min[item] = true
              }
            } else {
              min[item] = false;
            }
            this.updateFilterValue(index, "min", min);
          }}>
            <span className={`chk-box ${filter.min[item] ? 'checked' : ''}`}></span>
            <span className="chk-label">{item}</span>
            {
              item !== 'NOW' && 
              <NumberFormat
                className="form-control form-control-sm px-1 ml-1 text-right"
                inputMode="numeric"
                placeholder=""
                style={{color: 'white', maxWidth: '40px', height: '24px'}}
                disabled={!filter.min[item]}
                value={filter.min[item] || ''}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onValueChange={(values) => {
                  const min = filter.min;
                  min[item] = values.value;
                  if (item === 'PRE') {
                    if (min[item] !== '' && min[item] < 1) {
                      min[item] = 1;
                    }
                  }
                  if (item === 'POST') {
                    if (min[item] !== '') {
                      if (min[item] < -5) {
                        min[item] = -5;
                      } else if (min[item] > -1) {
                        min[item] = -1;
                      }
                    }
                  }
                  this.updateFilterValue(index, "min", min);
                }}
                />
            }
          </div>
        ))
      }
      </div>
    );
  }

  renderTrendFilterItem = (index, filter) => {
    const trendOptions = [TREND_TYPE.BUY, TREND_TYPE.SELL];
    return (
      <div className="d-flex justify-content-end align-items-center flex-grow-1">
        <Dropdown varaint="btn btn-outline-secondary" className="mx-2" style={{borderBottom: '1px solid white'}}>
          <Dropdown.Toggle className="industry_input d-flex align-items-center px-1">
          { this.renderTrendStatusItem(filter.min) }
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {trendOptions.map((option) => {
              return (
                <Dropdown.Item
                  key={`filter-trend-${option}`}
                  onClick={() => {
                    this.updateFilterValue(index, "min", option);
                  }}
                  tabIndex="1"
                >
                  { this.renderTrendStatusItem(option) }
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  renderTrendChangeFilterItem = (index, filter) => {
    const trendChangeOptions = [TREND_CHANGE_TYPE.BUY_TO_SELL, TREND_CHANGE_TYPE.SELL_TO_BUY];
    return (
      <div className="d-flex justify-content-end align-items-center flex-grow-1">
        <Dropdown varaint="btn btn-outline-secondary" className="mx-2" style={{borderBottom: '1px solid white'}}>
          <Dropdown.Toggle className="industry_input d-flex align-items-center px-1">
            {
              filter.min === TREND_CHANGE_TYPE.BUY_TO_SELL &&
              <div className="d-flex justify-content-between align-items-center">
                { this.renderTrendStatusItem(TREND_TYPE.BUY) }
                <span className="mx-1">&rarr;</span>
                { this.renderTrendStatusItem(TREND_TYPE.SELL) }
              </div>
            }
            {
              filter.min === TREND_CHANGE_TYPE.SELL_TO_BUY &&
              <div className="d-flex justify-content-between align-items-center">
                { this.renderTrendStatusItem(TREND_TYPE.SELL) }
                <span className="mx-1">&rarr;</span>
                { this.renderTrendStatusItem(TREND_TYPE.BUY) }
              </div>
            }
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {trendChangeOptions.map((option) => {
              return (
                <Dropdown.Item
                  key={`filter-trend-change-${option}`}
                  onClick={() => {
                    this.updateFilterValue(index, "min", option);
                  }}
                  tabIndex="1"
                >
                  {
                    option === TREND_CHANGE_TYPE.BUY_TO_SELL &&
                    <div className="d-flex justify-content-between align-items-center">
                      { this.renderTrendStatusItem(TREND_TYPE.BUY) }
                      <span className="mx-1">&rarr;</span>
                      { this.renderTrendStatusItem(TREND_TYPE.SELL) }
                    </div>
                  }
                  {
                    option === TREND_CHANGE_TYPE.SELL_TO_BUY &&
                    <div className="d-flex justify-content-between align-items-center">
                      { this.renderTrendStatusItem(TREND_TYPE.SELL) }
                      <span className="mx-1">&rarr;</span>
                      { this.renderTrendStatusItem(TREND_TYPE.BUY) }
                    </div>
                  }
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  renderTrendStatusItem = (option) => {
    return (
      <div className="d-flex justify-content-start align-items-center">
        <div className={`trend-wrapper ${option === TREND_TYPE.BUY ? 'trending mb-1' : 'mb-1'} mr-2`}>
          <div className="triangle"></div>
        </div>
        <span style={{textTransform: 'capitalize'}}>
          {option}
        </span>
      </div>
    )
  }

  renderLastAtFilterItem = (index, filter) => {
    const { threshold, unit } = filter.min || {};
    return (
      <div className="d-flex flex-column flex-sm-row justify-content-end align-items-baseline align-items-sm-center flex-grow-1 pl-1 pl-sm-4">
        {/* <div className={`input-group-checkbox`} onClick={() => {
        }}>
          <span className={`chk-box checked`}></span>
        </div> */}
        <div className="d-flex align-items-center justify-content-between">
          <NumberFormat
            className="form-control form-control-sm px-1 ml-1 text-right"
            inputMode="numeric"
            placeholder=""
            style={{color: 'white', maxWidth: '40px', marginTop: '2px'}}
            value={threshold}
            onValueChange={(values) => {
              this.updateFilterValue(index, "min", {
                threshold: values.value,
                unit
              });
            }}
          />
          <Dropdown varaint="btn btn-outline-secondary" className="ml-2" style={{borderBottom: '1px solid white'}}>
              <Dropdown.Toggle className="industry_input px-1">
                <span className="" style={{}}>{unit || 'unit'}</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {LAST_AT_FILTER_UNIT.map((key) => {
                  return (
                    <Dropdown.Item
                      key={key}
                      onClick={() => {
                        this.updateFilterValue(index, "min", {
                          threshold,
                          unit: key
                        });
                      }}
                      tabIndex="1"
                    >
                      <span
                        style={{
                          color: `${
                            key === unit ? "#f6c548" : ""
                          }`,
                        }}>
                        {key}
                      </span>
                    </Dropdown.Item>
                  );
                })}                                                                                                                                                         
              </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    );
  }

  getFilterSectorValue = (filterSector) => {
    if (filterSector.length === 1) return filterSector[0];
    const labels = Object.keys(SECTORS_FILTER);
    for (let item of labels) {
      if (filterSector.includes(item)) {
        return item + ` [${filterSector.length - 1}]`;
      }
    }
    return "";
  }

  updateFilterSector = (sector) => {
    let { filterSector } = this.state;
    if (!Array.isArray(filterSector)) filterSector = [];
    if (filterSector.includes(sector)) {
      filterSector = filterSector.filter(item => item !== sector)
    } else {
      if (filterSector.includes(DEFAULT_DISCOVERY_SECTOR)) {
        filterSector = [];
      }
      filterSector.push(sector);
    }
    if (filterSector.includes(DEFAULT_DISCOVERY_SECTOR)) filterSector = [DEFAULT_DISCOVERY_SECTOR];
    this.setState({
      filterSector: [...filterSector]
    })
  }

  isFieldDisabled = (column) => {
    if (column === 'trend') {
      return this.state.filters.map((f) => f.column).includes('trend_change')
    }
    if (column === 'trend_change') {
      return this.state.filters.map((f) => f.column).includes('trend')
    }
    return false;
  }

  render() {
    const { open, onHide } = this.props;
    const { filterSector, filterTimeframe, filters, loading, isFormSubmitted, sectorDropdownShown } = this.state;
    const errors = [];
    if (isFormSubmitted && !this.isFormValidSingleColumn()) {
      errors.push("Condition requires additional row of criteria.");
    }
    if (isFormSubmitted && !this.isFormValidMinMax()) {
      errors.push("Max value must not be less than Min value.");
    }
    return (
      <Modal
        id="setting-filtered-alert-modal"
        show={open}
        onHide={() => {
          onHide(false);
        }}
        aria-labelledby="example-modal-sizes-title-md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <Form.Control
              size="sm"
              type="text"
              placeholder="Enter filter name"
              style={{ width: 200, color: 'white' }}
              value={this.state.name}
              onChange={(e) => {
                e.preventDefault();
                this.updateFilterName(e.target.value);
              }}
            />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="filtered-alerts">
          <div className="section-header">
            <hr /><span>Condition</span><hr />
          </div>
          {this.state.filters.map((filter, index) => (
            <Form.Group
              className="d-flex align-items-center mb-0"
              key={`filter-${index}`}
            >
              <Dropdown
                varaint="btn btn-outline-secondary"
                style={{
                  border: "1px solid rgb(128, 128, 128)",
                  borderRadius: 4,
                  padding: 2,
                }}
              >
                <Dropdown.Toggle
                  className="industry_input"
                  id="dropdown-basic"
                  style={{ width: 120 }}
                >
                  {filter.column
                    ? this.getColumnTitle(filter.column)
                    : "Column"}
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-2-columns">
                  {this.columns
                    .filter(
                      (c) =>
                        !this.state.filters.map((f) => f.column).includes(c)
                    )
                    .map((c, i) => (
                      <Dropdown.Item
                        key={`filter-column-value-${i}`}
                        onClick={() => {
                          this.updateFilterColumn(index, c);
                        }}
                        disabled={this.isFieldDisabled(c)}
                      >
                        <span className={`${this.isFieldDisabled(c) ? 'text-symbol' : ''}`}>
                          {this.getColumnTitle(c)}
                        </span>
                      </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
              </Dropdown>
              <div className="d-flex align-items-center justify-content-end flex-grow-1">
                {
                  filter.column === 'squeeze' && this.renderSqueezeFilterItem(index, filter)
                }
                {
                  filter.column === 'trend' && this.renderTrendFilterItem(index, filter)
                }
                {
                  filter.column === 'trend_change' && this.renderTrendChangeFilterItem(index, filter)
                }
                {
                  (filter.column === 'news' || filter.column === 'halt') && this.renderLastAtFilterItem(index, filter)
                }
                {
                  this.isSingleValueColumn(filter.column) && this.renderSingleValueFilterItem(index, filter)
                }
                {
                  (!filter.column || this.isMinMaxColumn(filter.column)) && this.renderMinMaxFilterItem(index, filter)
                }
                <i
                  className="mdi mdi-trash-can pl-2 pr-0 pl-sm-3 pr-sm-3 py-2"
                  role="button"
                  onClick={(e) => {
                    e.preventDefault();
                    this.deleteFilterRow(index);
                  }}
                />
              </div>
            </Form.Group>
          ))}

          {this.columns.length > this.state.filters.length ? (
            <div className="d-flex align-items-center justify-content-end">
              <div
                role="button"
                onClick={() => {
                  this.addRow();
                }}
              >
                <i className="mdi mdi-plus mt-3" />
                Add row
              </div>
            </div>
          ) : null}

          <Form.Group
            className="d-flex align-items-center justify-content-end mb-0"
            style={{ color: "white" }}
          >
            <Form.Check
              className="d-flex white"
              inline
              label={FILTER_TYPE.ALL}
              type="radio"
              id={`inline-radio-1`}
              name="type"
              checked={this.state.type === FILTER_TYPE.ALL}
              onChange={(e) => {
                if (e.target.checked) {
                  this.updateFilterType(FILTER_TYPE.ALL);
                }
              }}
            />
            <Form.Check
              className="d-flex"
              inline
              label={FILTER_TYPE.ANY}
              type="radio"
              id={`inline-radio-2`}
              name="type"
              checked={this.state.type === FILTER_TYPE.ANY}
              onChange={(e) => {
                if (e.target.checked) {
                  this.updateFilterType(FILTER_TYPE.ANY);
                }
              }}
            />

            <span style={{ height: 20 }}>conditions met</span>
          </Form.Group>

          <div className="mt-1 mb-3">
          {
            errors.map((error, index) => {
              return <div key={`filtered-alert-error-${index}`} style={{color: 'rgb(252, 66, 74)', fontSize: '14px'}}>{error}</div>
            })
          }
          </div>

          <div className="section-header">
            <hr /><span>Attribute</span><hr />
          </div>
          <div className="d-flex align-items-bottom flex-wrap">
            <span>For</span>
            <Dropdown varaint="btn btn-outline-secondary" className="mx-2" style={{borderBottom: '1px solid white'}}
              show={sectorDropdownShown}
              onToggle={(isOpen, event, metadata) => {
                if(isOpen || metadata.source!=='select'){
                  this.setState({
                    sectorDropdownShown: isOpen
                  })
                }
                // event.persist();
              }}>
              <Dropdown.Toggle className="industry_input px-1">
                {
                  !Array.isArray(filterSector) || filterSector.length === 0 ?
                  <span className="" style={isFormSubmitted ? {color: 'rgb(252, 66, 74)'} : {}}>Category</span>
                  :
                  <span>{this.getFilterSectorValue(filterSector)}</span>
                }
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {[DEFAULT_DISCOVERY_SECTOR, ...Object.keys(SECTORS_FILTER).sort((a, b) => {
                  if (a === 'MISCELLANEOUS') return 1;
                  if (b === 'MISCELLANEOUS') return -1;
                  if (a < b) return -1;
                  if (b < a) return 1;
                  return 0;
                })].map((sector) => {
                  return (
                    <Dropdown.Item
                      key={sector}
                      onClick={() => {
                        this.updateFilterSector(sector)
                      }}
                      tabIndex="1"
                    >
                      <span
                        style={{
                          color: `${
                            filterSector.includes(sector) ? "#f6c548" : ""
                          }`,
                        }}>
                        {sector}
                      </span>
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
            <span>based on</span>
            <Dropdown varaint="btn btn-outline-secondary" className="mx-2" style={{borderBottom: '1px solid white'}}>
              <Dropdown.Toggle className="industry_input px-1">
                {
                  TIMEFRAME_FILTER[filterTimeframe] ?
                  <span>{TIMEFRAME_FILTER[filterTimeframe]}</span>
                  :
                  <span className="" style={isFormSubmitted ? {color: 'rgb(252, 66, 74)'} : {}}>Timeframe</span>
                }
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {[...Object.keys(TIMEFRAME_FILTER)].map((key) => {
                  return (
                    <Dropdown.Item
                      key={key}
                      onClick={() => {
                        this.setState({
                          filterTimeframe: key
                        })
                      }}
                      tabIndex="1"
                    >
                      <span
                        style={{
                          color: `${
                            key === filterTimeframe ? "#f6c548" : ""
                          }`,
                        }}>
                        {TIMEFRAME_FILTER[key]}
                      </span>
                    </Dropdown.Item>
                  );
                })}                                                                                                                                                         
              </Dropdown.Menu>
            </Dropdown>
            <span>rate of change.</span>
          </div>
        </Modal.Body>

        <Modal.Footer className="justify-content-between">
          <Button variant="secondary" onClick={() => this.clear()}>
            Clear
          </Button>
          {
            this.state.mode === 'add' ?
            <div>
              <Button
                variant="success"
                onClick={() => {
                  this.handleSave();
                }}
                disabled={!this.isFormValidBasic() || loading}
              >
                Save Filter
              </Button>
            </div>
            :
            <div>
              <Button
                variant="primary"
                onClick={() => {
                  this.handleUpdate();
                }}
                disabled={!this.isFormValidBasic() || loading}
              >
                Update
              </Button>
            </div>
          }
        </Modal.Footer>
      </Modal>
    );
  }
}

export default SettingFilteredAlertModal;
